import request from '@/utils/zsm-requets'
const shop='/zsm/api/shop/'
/** 创建店铺
        avatar	店铺图像
        string
        desc	详细描述
        string
        frontId	门店编号
        id	门店编号
        realName	真实姓名
        shareTitle	分享标题
        shopDict	店铺类型
 */
export function createShop(shopInfo) {
  return request({
    url: shop+'create',
    method: 'post',
    params: shopInfo
  })
}




/* 获取店铺列表
       avatar	店铺图像
       desc	详细描述
       frontId	门店编号
       id	门店编号
       realName	真实姓名
       shareTitle	分享标题
       shopDict	店铺类型
 */
export function listDataShop(shopInfo) {
  return request({
    url: shop+'listData',
    method: 'post',
    params: shopInfo
  })
}

/** 修改店铺信息
        avatar	店铺图像
        string
        desc	详细描述
        string
        frontId	门店编号
        id	门店编号
        realName	真实姓名
        shareTitle	分享标题
        shopDict	店铺类型
 */
export function updateShop(shopInfo) {
  return request({
    url:shop+'update',
    method: 'post',
    params: shopInfo
  })
}


/**
 // 更新讲师联系电话的开启状态
 * @param flag	0关闭  1开启
 * @param id	店铺id
 *
 */
export function updateTeacherMobileFlag( params ) {
  return request({
    url: shop+'updateTeacherMobileFlag',
    method: 'post',
    params
  })
}



/**
 // 更新讲师联系微信的开启状态
 * @param flag	0关闭  1开启
 * @param id	店铺id
 *
 */
export function updateTeacherWeixinFlag( params) {
  return request({
    url: shop+'updateTeacherWeixinFlag',
    method: 'post',
    params
  })
}

/**
 // 更新讲师联系微信的开启状态
 * @param flag	0关闭  1开启
 * @param id	店铺id
 *
 */
export function updateTeacherDouyinFlag( params) {
  return request({
    url: shop+'updateTeacherDouyinFlag',
    method: 'post',
    params
  })
}

/**
 // 更新讲师联系快手的开启状态
 * @param flag	0关闭  1开启
 * @param id	店铺id
 *
 */
export function updateTeacherKuaishouFlag( params) {
  return request({
    url: shop+'updateTeacherKuaishouFlag',
    method: 'post',
    params
  })
}
